var _path, _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 -4.82049e-07 10 0C4.486 4.82049e-07 -4.82049e-07 4.486 0 10C4.82049e-07 15.514 4.486 20 10 20ZM11 14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14V10C9 9.44772 9.44771 9 10 9C10.5523 9 11 9.44772 11 10V14ZM10 5C9.44771 5 9 5.44771 9 6C9 6.55229 9.44771 7 10 7C10.5523 7 11 6.55229 11 6C11 5.44771 10.5523 5 10 5Z",
    fill: "#F6BC18"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.7555dc195e66e28b7932810204eb39bb.svg";
export { ForwardRef as ReactComponent };